var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseAdapter } from './base';
import { PlatformEnum, } from '../utils';
import { EnvironmentDetector } from '../core';
/**
 * Liteapp 平台适配器
 * 将 Liteapp 的 API 映射到统一的 Platform 接口
 */
export class LiteappAdapter extends BaseAdapter {
    constructor() {
        super();
        this.platformType = PlatformEnum.LiteApp;
        /** 全局数据配置 */
        this.globalDataConfig = {};
        this.env = EnvironmentDetector.getEnvironmentInfo();
        this.capabilities = EnvironmentDetector.detectCapabilities(this.platformType);
    }
    // ========== 重写getter以直接访问liteapp ==========
    // get scrollX(): number {
    //   return 0;
    // }
    // get scrollY(): number {
    //   return 0;
    // }
    // override get document(): Document {
    //   // TODO: 实现liteapp的document
    // }
    // override addEventListener(
    //   type: string,
    //   listener: EventListenerOrEventListenerObject,
    //   options?: boolean | AddEventListenerOptions,
    // ): void {
    //   if (type === 'resize' && typeof lite !== 'undefined' && lite.onWindowResize) {
    //     lite.onWindowResize(listener);
    //   } else {
    //     // 使用基类的默认实现
    //     this.defaultAddEventListener(type, listener, options);
    //   }
    // }
    // override removeEventListener(
    //   type: string,
    //   listener: EventListenerOrEventListenerObject,
    //   options?: boolean | EventListenerOptions,
    // ): void {
    //   if (type === 'resize' && typeof lite !== 'undefined' && lite.offWindowResize) {
    //   } else {
    //     // 使用基类的默认实现
    //     this.defaultRemoveEventListener(type, listener, options);
    //   }
    // }
    //
    // override requestAnimationFrame(callback: FrameRequestCallback): number {
    //   if (typeof lite !== 'undefined' && lite.requestAnimationFrame) {
    //     return lite.requestAnimationFrame(callback);
    //   }
    //   // 使用 setTimeout 模拟
    //   return setTimeout(callback, 16) as unknown as number;
    // }
    // override fetch(input: RequestInfo, init?: RequestInit): Promise<Response> {
    //   if (typeof lite !== 'undefined' && lite.request) {
    //     // 将 fetch 转换为 lite.request
    //     return this.liteappRequest(input, init);
    //   }
    //   // 使用基类的默认实现
    //   return this.defaultFetch(input, init);
    // }
    getDefaultLocalStorage() {
        return {
            get length() {
                return 0; // LiteApp KV 不支持获取长度
            },
            key: function (index) {
                return null; // LiteApp KV 不支持按索引获取键名
            },
            clear: function () {
                lite.kv.clear();
            },
            /** 特别小心，这里是异步读取！！ */
            getItem: function (key) {
                return __awaiter(this, void 0, void 0, function* () {
                    const value = yield lite.kv.getItem(key);
                    if (value === undefined || value === null)
                        return null;
                    return value;
                });
            },
            removeItem: function (key) {
                var _a, _b;
                (_b = (_a = lite.kv.removeItem(key)) === null || _a === void 0 ? void 0 : _a.catch) === null || _b === void 0 ? void 0 : _b.call(_a, () => {
                    // 静默处理
                });
            },
            setItem: function (key, value) {
                var _a, _b;
                if (value === undefined || value === null)
                    return;
                (_b = (_a = lite.kv.setItem(key, value)) === null || _a === void 0 ? void 0 : _a.catch) === null || _b === void 0 ? void 0 : _b.call(_a, () => {
                    // 静默处理
                });
            }
        };
    }
    /**
     * 获取Cookie
     * @param {string} name - 要获取的Cookie名称
     * @returns {string} Cookie值或空字符串（如果不存在）
     */
    getDefaultCookie(name) {
        const { cookieUrl } = this.getGlobalDataConfig();
        if (!cookieUrl) {
            console.warn('liteapp getCookie need set cookieUrl with setGlobalDataConfig');
            return '';
        }
        const cookies = lite.cookie.get(cookieUrl) || '';
        const regex = new RegExp(`(^| )${name}=([^;]+)`);
        const match = cookies.match(regex);
        return (match === null || match === void 0 ? void 0 : match[2]) ? decodeURIComponent(match[2]) : '';
    }
    /**
     * 设置Cookie
     * @param {string} name - Cookie名称
     * @param {string} value - Cookie值
     * @param {number} days - 过期天数（默认7天）
     * @param {string} path - 有效路径（默认'/'）
     * @param {string} domain - 有效域名（默认当前域名）
     * @param {boolean} secure - 是否仅HTTPS传输（默认false）
     */
    setDefaultCookie(options) {
        const { name, value, days = 7, path = '', domain = '', secure = false } = options;
        if (!name || !value || !domain || !path) {
            console.error('liteapp setCookie name, value, domain and path are required');
            return;
        }
        let cookieString = `${name}=${encodeURIComponent(value)}`;
        // 设置过期时间
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            cookieString += `; expires=${date.toUTCString()}`;
        }
        // 设置路径
        cookieString += `; path=${path}`;
        // 设置域名
        if (domain) {
            cookieString += `; domain=${domain}`;
        }
        // 设置Secure标志
        if (secure) {
            cookieString += '; Secure';
        }
        // !! 注意：如果 setCookie 之后在 liteapp 开发者工具看不到，需要https://${domain}${path} 先发起请求，liteapp 开发者工具才能看到，但是实际上是 setCookie 成功的。
        const url = `https://${domain}${path}`;
        lite.cookie.set(url, cookieString);
    }
    // protected doDefaultFetch(input: RequestInfo, init?: RequestInit): Promise<Response> {
    //   if (typeof lite !== 'undefined' && lite.request) {
    //     return lite.request(input, init);
    //   }
    //   return Promise.reject(new Error('fetch not supported'));
    // }
    getDefaultNavigator() {
        return {
            userAgent: lite.system.getUserAgent(),
            sendBeacon: lite.system.sendBeacon,
        };
    }
    getDefaultLocation() {
        var _a;
        return {
            pathname: ((_a = lite.router) === null || _a === void 0 ? void 0 : _a.currentRoute) || '',
        };
    }
    getDefaultDocument() {
        return document;
    }
    /** 设置全局数据配置（增量合并） */
    setGlobalDataConfig(config) {
        Object.assign(this.globalDataConfig, config);
    }
    /** 获取全局数据配置（只读） */
    getGlobalDataConfig() {
        return this.globalDataConfig;
    }
}
//# sourceMappingURL=liteapp.js.map